module.exports = __webpack_public_path__ + "img/10.d235782c.png";